export default __webpack_public_path__ + "static/media/wsp.e283b245.png";